import React from 'react';
import type { Block, Inline } from '@app/lib/blog';
import pageStyles from '../pageStyles.module.css';
import styles from './style.module.css';

function renderInline(items: Inline[]): React.ReactNode[] {
  return items.map((i, k) => {
    if (i.t === 'b') return <strong key={k}>{i.v}</strong>;
    if (i.t === 'a') {
      const external = /^https?:\/\//.test(i.href);
      return (
        <a key={k} href={i.href} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
          {i.v}
        </a>
      );
    }
    if (i.t === 'br') return <br key={k} />;
    return <React.Fragment key={k}>{i.v}</React.Fragment>;
  });
}

/** Тело статьи из разобранных блоков (см. app/lib/blog.ts). */
const BlogContent: React.FC<{ blocks: Block[] }> = ({ blocks }) => (
  <>
    {blocks.map((b, k) => {
      switch (b.t) {
        case 'h2':
          return (
            <h2 key={k} className={pageStyles.h2}>
              {b.text}
            </h2>
          );
        case 'h3':
          return (
            <h3 key={k} className={pageStyles.h3}>
              {b.text}
            </h3>
          );
        case 'p':
          return (
            <p key={k} className={pageStyles.text}>
              {renderInline(b.inl)}
            </p>
          );
        case 'ul':
          return (
            <ul key={k} className={pageStyles.list}>
              {b.items.map((item, j) => (
                <li key={j}>{renderInline(item)}</li>
              ))}
            </ul>
          );
        case 'img':
          return (
            <figure key={k} className={styles.figure}>
              <img src={b.src} alt={b.alt} loading="lazy" decoding="async" />
              <figcaption>
                {b.alt}
                {b.credit && (
                  <span className={styles.credit}>
                    {' · '}
                    {b.creditUrl ? (
                      <a href={b.creditUrl} target="_blank" rel="noopener noreferrer">
                        {b.credit}
                      </a>
                    ) : (
                      b.credit
                    )}
                  </span>
                )}
              </figcaption>
            </figure>
          );
        case 'cta':
          return (
            <div key={k} className={`${pageStyles.ctaRow} ${styles.cta}`}>
              <a className={pageStyles.cta} href={b.href}>
                {b.text}
              </a>
            </div>
          );
      }
    })}
  </>
);

export default BlogContent;
